import { FormBase } from './form-base';

export class DateClass extends FormBase<string> {
    controlType = 'date';
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}